<div fxLayout.lt-lg="column"
     fxLayout.gt-md="row"
     fxLayoutAlign="space-around center"
     class="login-page">
    <div class="form-wrapper"
         fxLayout="column"
         fxLayoutAlign.lt-lg="space-between center"
         fxLayoutAlign.gt-md="center center"
         [ngStyle.gt-md]="{'height.vh': 100, 'width.vw': 50, 'padding.px': 50, 'padding-top.px': 0}">
        <div class="login-page__welcome-message">
            <div class="logo-wrapper">
                <img src="assets/images/full-logo.svg"
                     class="login-logo"
                     alt="SalesRun Logo">
            </div>
            <div class="login-page__welcome-message__header">
                Welcome to SalesRun v5.0
            </div>
            <div class="login-page__welcome-message__footer">
                Enter your details below here
            </div>
        </div>

        <form [formGroup]="loginForm"
              novalidate
              fxLayout="column"
              fxLayoutAlign="space-between stretch"
              [ngStyle.gt-md]="{'min-width.px': 480}">
            <div fxLayout="column">
                <div fxLayout="row"
                     fxLayoutAlign="start center">
                    <mat-icon svgIcon="mdi:account">
                    </mat-icon>
                    <mat-form-field>
                        <input matInput
                               name="userName"
                               formControlName="userName"
                               placeholder="User Name" />
                        <mat-error *ngIf="loginForm.get('userName').hasError('required')">
                            Username is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="password"
                     [class.password--hidden]="!isPasswordLogin"
                     fxLayout="row"
                     fxLayoutAlign="start center">
                    <mat-icon svgIcon="mdi:lock">
                    </mat-icon>
                    <mat-form-field>
                        <span fxLayout="row">
                            <input #password
                                   matInput
                                   [type]="showPassword ? 'text' : 'password' "
                                   name="password"
                                   formControlName="password"
                                   placeholder="Password" />
                            <mat-icon svgIcon="{{ showPassword ? 'mdi:eye-off' : 'mdi:eye' }}"
                                      (click)="switchShowPassword()">
                            </mat-icon>
                        </span>
                        <mat-error *ngIf="loginForm.get('password').hasError('required')">
                            Password is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="error-container">
                <mat-error *ngIf="error">{{errorMsg}}</mat-error>
            </div>
            <div fxLayout="row"
                 fxLayout.xs="column"
                 fxLayoutAlign="space-between">
                <a mat-button
                    color="accent"
                    [routerLink]="['request-password']">Forgot your password?</a>
                <ng-container *ngIf="isPasswordLogin">

                    <button mat-raised-button
                            type="submit"
                            color="accent"
                            (click)="login()"
                            [disabled]="loading">
                        {{loading ? 'Logging in..' : 'LOGIN'}}
                    </button>
                </ng-container>
                <ng-container *ngIf="!isPasswordLogin">
                    <button mat-raised-button
                            type="submit"
                            color="accent"
                            (click)="continue()"
                            [disabled]="loading">
                        {{loading ? 'Loading..' : 'CONTINUE'}}
                    </button>
                </ng-container>


            </div>
        </form>
        <div class="login-page__footer">
            <span class="copyright">© 2022 - {{utcNow | srpTimezoneDate: 'yyyy'}} SalesRun. All rights reserved</span>
        </div>
    </div>

    <div class="login-page__slider-container"
         fxHide.lt-lg>
        <swiper [config]="config">
            <ng-container *ngFor="let item of carouselItems">
                <ng-template swiperSlide>
                    <div class="swiper-slide">
                        <div class="swiper-slide-content">
                            <div class="img-area">
                                <img class="best-fit"
                                     [src]="item.image">
                            </div>
                            <h4 class="login-page__slider-content__title">
                                {{item.title}}
                            </h4>
                            {{item.caption}}
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </swiper>
    </div>
</div>